import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";
import { errText } from "@/lib/api";
import { toast } from "sonner";
import Logo from "@/components/Logo";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("admin@korewellbeing.co.uk");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await login(email, password); nav("/admin"); toast.success("Welcome back."); }
    catch (err) { toast.error(errText(err)); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-kore-forest text-kore-warm flex items-center justify-center p-6">
      <form onSubmit={submit} data-testid="admin-login" className="w-full max-w-md bg-white/[0.03] backdrop-blur rounded-3xl p-10 border border-kore-light/20 space-y-6">
        <div>
          <div className="text-kore-light">
            <Logo size="lg" asLink={false} />
          </div>
          <div className="text-[11px] uppercase tracking-[0.24em] text-kore-light mt-4">Kore CMS</div>
          <h1 className="font-display text-4xl mt-2 font-light">Sign in.</h1>
        </div>
        <div>
          <label className="text-[11px] uppercase tracking-[0.22em] text-kore-light">Email</label>
          <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" className="mt-2 w-full bg-transparent border-b border-kore-warm/30 focus:border-kore-light py-2 focus:outline-none" />
        </div>
        <div>
          <label className="text-[11px] uppercase tracking-[0.22em] text-kore-light">Password</label>
          <input required type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" className="mt-2 w-full bg-transparent border-b border-kore-warm/30 focus:border-kore-light py-2 focus:outline-none" />
        </div>
        <button disabled={busy} data-testid="login-submit" className="btn-gold w-full">{busy ? "…" : "Sign in"}</button>
      </form>
    </div>
  );
}
